export abstract class _Comment {
  id: string;
  user: string;
  move: Array<any>;
  message: string;
  createdDate: number;
  ticket_id: string;

}